// Copyright (c) 2016 Deere & Company

import DateCellRenderer from '../../shared/report-cell-renderers/date-cell-renderer';
import PinCellRenderer from '../../shared/report-cell-renderers/pin-cell-renderer';
import classNames from '../../shared/constants/ag-grid-class-names';
import dateFilterParams from '../../shared/constants/date-filter-params';
import {translate} from '../../../shared/services/translation-service';

export function getDeliveryNoDocumentsColumnDefinitions() {

    return [
        {
            cellClass: classNames.cellLeftClassName,
            cellRendererFramework: PinCellRenderer,
            colId: 'pin',
            field: 'pin',
            headerClass: classNames.headerLeftClassName,
            headerName: translate('PIN'),
            width: 190
        },
        {
            cellClass: classNames.cellClassName,
            colId: 'responsibleDealer',
            field: 'responsibleDealer',
            headerClass: classNames.headerClassName,
            headerName: translate('ACCOUNT'),
            width: 100
        },
        {
            cellClass: classNames.cellLeftClassName,
            colId: 'dealerCity',
            field: 'dealerCity',
            headerClass: classNames.headerLeftClassName,
            headerName: translate('LOCATION'),
            width: 200
        },
        {
            cellClass: classNames.cellLeftClassName,
            colId: 'customerName',
            field: 'customerName',
            headerClass: classNames.headerLeftClassName,
            headerName: translate('CUSTOMER_NAME'),
            width: 200
        },
        {
            cellClass: classNames.cellClassName,
            cellRendererFramework: DateCellRenderer,
            colId: 'deliveryDate',
            field: 'deliveryDate',
            filter: 'date',
            filterParams: dateFilterParams,
            headerClass: classNames.headerClassName,
            headerName: translate('DELIVERED'),
            width: 120
        },
        {
            cellClass: classNames.cellClassName,
            cellRendererFramework: DateCellRenderer,
            colId: 'registrationDate',
            field: 'registrationDate',
            filter: 'date',
            filterParams: dateFilterParams,
            headerClass: classNames.headerClassName,
            headerName: translate('REGISTERED'),
            width: 120
        },
        {
            cellClass: classNames.cellClassName,
            cellRendererFramework: DateCellRenderer,
            colId: 'invoiceDate',
            field: 'invoiceDate',
            filter: 'date',
            filterParams: dateFilterParams,
            headerClass: classNames.headerClassName,
            headerName: translate('INVOICED'),
            width: 120
        }
    ];

}



// WEBPACK FOOTER //
// ./src/reports/delivery-no-documents/report-services/column-definitions.js